export default __webpack_public_path__ + "static/media/deliver-everywhere.53b9eaad.gif";